









































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Filter } from '@/models/Filter';

@Component
export default class ListingFilter extends Vue {

    public widthThresholdValue: number = 1200;
    public heightThresholdValue: number = 415;

    get activeFilter(): Filter | null {
        return this.$store.state.filters.activeFilter;
    }

    get config() {
        return this.$store.state.config;
    }

    get isLoggedIn(): boolean {
        return this.$store.state.isLoggedIn;
    }

    get savedFilters() {
        return this.$store.state.filters.savedFilters;
    }

    get filterCount() {
        return this.$store.state.filters.filterCount;
    }

     get isMobile(): boolean {
        return (this.$q.screen.width <= this.widthThresholdValue) || (this.$q.screen.height <= this.heightThresholdValue);
    }

    public onSave() {
        if (!this.isLoggedIn) {
            this.$store.dispatch('showLoginPromptDialog', 'You must login to save filters.');
        } else {
            this.$store.dispatch('showFilterSaveDialog');
        }
    }

    public onClearAll() {
        this.$store.dispatch('clearActiveFilter');
    }

    public showFilterDialog() {
        console.log('showFilterDialog');
        this.$store.dispatch('showFilterDialog');
    }

    public mounted() {
        console.log('ListingFilter: mounted()');
        console.log(this.activeFilter);
    }
}
